package fr.labodoc.healthProfessional.webApp.data.model

data class LearnedSocietyModel(
    val id: String,
    val name: String,
    val acronym: String?,
    val websiteUrl: String,
    val forStudents: Boolean,
    val logoUrl: String?,
    val medicalSpecialityIds: Set<String>,
    val favorite: Boolean
)
